import React from "react";
import Slide from "@mui/material/Slide";
import Dialog from "@mui/material/Dialog";
import {Form, Formik} from "formik";

import UploadForm from "./UploadForm";
import {useStylesDialog} from "../../../shared/useStyleDialog";
import UploadDialogAppBar from "./UploadDialogAppBar";

const initialValues = {
    name: '',
    description: '',
    componenttypes: [],
    guid: '',
    id: null,
    instanceTypeId: null,
    deactivated: 0
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="left" ref={ref} {...props} />;
});

function UploadDialog({dataObjectSelected, uploadDialogOpen, setUploadDialogOpen, callbackFunc}) {
    const classesDialog = useStylesDialog();

    return (
        <Dialog
            className={classesDialog.dialog}
            open={uploadDialogOpen}
            onClose={() => setUploadDialogOpen(false)}
            TransitionComponent={Transition}
            fullScreen
        >
            <Formik
                initialValues={initialValues}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(false);
                }}
            >
                <Form>
                    <UploadDialogAppBar
                        setUploadDialogOpen={setUploadDialogOpen}
                    />

                    <UploadForm
                        dataObjectSelected={dataObjectSelected}
                        id={dataObjectSelected.id}
                        type={dataObjectSelected.administrativeobjectType ? 'administrativeobject': dataObjectSelected.realestateobjectType ? 'realestateobject' : 'component'}
                        callbackFunc={callbackFunc}
                    />
                </Form>
            </Formik>
        </Dialog>
    );
}

export default UploadDialog;
